(function () {
  'use strict';

  /* ========================================================
     Brillux Farbkonfigurator — CTA + Modal
     Preise aus price-lookup.json (BMECat), nicht aus Varianten
     ======================================================== */

  var ctaWrapper = document.getElementById('fk-cta-wrapper');
  if (!ctaWrapper) return;
  var ctaWrapperHtml = ctaWrapper.outerHTML;

  /* ---- Color System Registry (erweiterbar) ---- */
  var colorSystems = {
    scala: {
      parse: function (data) {
        var map = {};
        data.forEach(function (c) {
          if (!map[c.family_id]) {
            map[c.family_id] = {
              id: c.family_id,
              name: c.family_name,
              colors: [],
              representativeRgb: null
            };
          }
          map[c.family_id].colors.push(c);
        });

        var families = Object.keys(map).map(function (key) {
          var fam = map[key];
          fam.colors.sort(function (a, b) { return b.hbw - a.hbw; });
          var mid = Math.floor(fam.colors.length / 2);
          fam.representativeRgb = fam.colors[mid].rgb;
          return fam;
        });
        families.sort(function (a, b) { return a.name.localeCompare(b.name, 'de'); });

        return { families: families, colors: data };
      }
    }
  };

  /* ---- State ---- */
  var state = {
    colors: [],
    families: [],
    variants: [],
    sizeByVariantId: {},   // Alle Varianten-IDs → Größenwert (auch nicht-Wunschfarbe)
    wunschfarbeSizes: null,// Set normalisierter Größen mit Wunschfarbe-Variante (null = hasSize=false)
    priceLookup: null,     // BMECat Preis-Lookup
    skuPrefix: null,       // 4-stellige Produktnummer
    hasSize: true,
    selectedSize: null,
    selectedFamily: null,
    selectedColor: null,
    matchedVariant: null,
    resolvedPrice: null,   // Preis aus Lookup
    modalOpen: false
  };

  /* ---- DOM refs ---- */
  var dom = {};

  /* ---- Init ---- */
  function init() {
    var dataEl = document.getElementById('fk-product-data');
    if (!dataEl) return;

    var productData = JSON.parse(dataEl.textContent);
    state.variants = productData.variants;
    state.hasSize = productData.has_size !== false;
    state.sizeByVariantId = productData.size_by_variant_id || {};

    if (state.hasSize) {
      state.wunschfarbeSizes = {};
      state.variants.forEach(function (v) {
        var n = normalizeSize(v.size);
        if (n) state.wunschfarbeSizes[n] = true;
      });
    }

    // SKU-Prefix aus erster Wunschfarbe-Variante extrahieren (erste 4 Ziffern)
    for (var i = 0; i < state.variants.length; i++) {
      var sku = state.variants[i].sku;
      if (sku) {
        var match = sku.match(/^(\d{4})/);
        if (match) {
          state.skuPrefix = match[1];
          break;
        }
      }
    }

    // CTA binden
    var ctaBtn = document.getElementById('fk-cta');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', guardedOpenModal);
    }

    // Native Wunschfarbe-Varianten verstecken
    hideNativeVariants();

    // BCPO rendert Buttons oft asynchron → Retry nach kurzer Verzögerung
    setTimeout(function () { hideNativeVariants(); }, 500);
    setTimeout(function () { hideNativeVariants(); }, 1500);

    // Bei Shopify-Re-Render der Varianten erneut verstecken
    observeVariantChanges();

    // Modal DOM-Refs
    dom = {
      overlay: document.getElementById('fk-modal-overlay'),
      modal: document.getElementById('fk-modal'),
      closeBtn: document.getElementById('fk-modal-close'),
      sizes: document.getElementById('fk-sizes'),
      families: document.getElementById('fk-families'),
      colors: document.getElementById('fk-colors'),
      familyTitle: document.getElementById('fk-family-title'),
      search: document.getElementById('fk-search'),
      searchResults: document.getElementById('fk-search-results'),
      summary: document.getElementById('fk-summary'),
      summarySwatch: document.getElementById('fk-summary-swatch'),
      summaryId: document.getElementById('fk-summary-id'),
      summaryName: document.getElementById('fk-summary-name'),
      summarySize: document.getElementById('fk-summary-size'),
      summaryPrice: document.getElementById('fk-summary-price'),
      summaryUnitPrice: document.getElementById('fk-summary-unit-price'),
      addToCart: document.getElementById('fk-add-to-cart'),
      feedback: document.getElementById('fk-feedback')
    };

    // Farbsystem + Preise laden (parallel)
    var systemName = dom.modal.getAttribute('data-color-system') || 'scala';
    var colorsUrl = dom.modal.getAttribute('data-colors-url');
    var pricesUrl = '/apps/farbkonfigurator/prices';

    var colorsReady = fetch(colorsUrl).then(function (r) { return r.json(); });
    var pricesReady = pricesUrl
      ? fetch(pricesUrl).then(function (r) { return r.json(); })
      : Promise.resolve(null);

    Promise.all([colorsReady, pricesReady])
      .then(function (results) {
        var system = colorSystems[systemName];
        if (!system) return;

        var parsed = system.parse(results[0]);
        state.colors = parsed.colors;
        state.families = parsed.families;
        state.priceLookup = results[1];

        if (state.hasSize) {
          renderSizes();
        } else {
          state.selectedSize = null;
          renderFamilies();
          goToStep(2);
        }
      })
      .catch(function (err) {
        console.error('[Farbkonfigurator] Fehler beim Laden:', err);
      });

    // Step 1 ausblenden wenn keine Größe
    if (!state.hasSize) {
      var step1El = dom.modal.querySelector('.fk-step[data-step="1"]');
      var divider1 = step1El ? step1El.nextElementSibling : null;
      if (step1El) step1El.style.display = 'none';
      if (divider1 && divider1.classList.contains('fk-step__divider')) divider1.style.display = 'none';
    }

    bindModalEvents();
    bindWizardEvents();
  }

  /* ---- Preis-Lookup ---- */
  function lookupPrice(priceGroup, size) {
    if (!state.priceLookup || !state.skuPrefix) return null;

    var product = state.priceLookup[state.skuPrefix];
    if (!product) return null;

    var pg = String(priceGroup);

    // Mit Größe suchen
    if (size && product.sizes[size] && product.sizes[size][pg]) {
      return product.sizes[size][pg];
    }

    // Ohne Größe: erste verfügbare Größe mit diesem PG nehmen
    if (!size) {
      var sizeKeys = Object.keys(product.sizes);
      for (var i = 0; i < sizeKeys.length; i++) {
        if (product.sizes[sizeKeys[i]][pg]) {
          return product.sizes[sizeKeys[i]][pg];
        }
      }
    }

    return null;
  }

  /* ---- Native Varianten verstecken ---- */
  var variantObserver = null;
  var variantObserverTarget = null;

  function pauseObserver() {
    if (variantObserver) variantObserver.disconnect();
  }

  function resumeObserver() {
    if (variantObserver && variantObserverTarget) {
      variantObserver.observe(variantObserverTarget, { childList: true, subtree: true });
    }
  }

  function hideNativeVariants() {
    var ctaEl = document.getElementById('fk-cta-wrapper');

    // Prüfen ob bereits alles korrekt ist (CTA vorhanden + Labels versteckt)
    if (ctaEl && ctaEl.parentNode) {
      var alreadyDone = true;
      var labels = document.querySelectorAll(
        'fieldset label, .product-form__input label, .selector-wrapper label'
      );
      labels.forEach(function (lbl) {
        if ((lbl.textContent || '').indexOf('Wunschfarb') !== -1 && lbl.style.display !== 'none') {
          alreadyDone = false;
        }
      });
      if (alreadyDone) return;
    }

    pauseObserver();

    // CTA wurde durch Shopify-Re-Render zerstört → neu erstellen
    if (!ctaEl) {
      var temp = document.createElement('div');
      temp.innerHTML = ctaWrapperHtml;
      ctaEl = temp.firstElementChild;
      var ctaBtn = ctaEl.querySelector('#fk-cta');
      if (ctaBtn) ctaBtn.addEventListener('click', guardedOpenModal);
    }

    var colorContainer = null;

    // 1. Alle Labels/Inputs mit "Wunschfarbe" finden und als Modal-Trigger binden
    var bcpoBound = false;
    var allVariantLabels = document.querySelectorAll(
      'fieldset label, .product-form__input label, .selector-wrapper label, ' +
      '.bcpo-front-button-label, .variant-button-wrap label, .variant-input-wrap label'
    );
    allVariantLabels.forEach(function (lbl) {
      var text = lbl.textContent || '';
      if (text.indexOf('Wunschfarb') !== -1) {
        // Sichtbar halten — Expanse Theme versteckt nicht-verfügbare Varianten,
        // aber Wunschfarbe soll immer sichtbar bleiben als Modal-Trigger
        lbl.style.display = '';
        lbl.style.visibility = 'visible';
        var input = lbl.previousElementSibling;
        if (input && input.tagName === 'INPUT') {
          input.style.display = '';
        }
        // Auch den Container sichtbar machen
        var wrapper = lbl.closest('.variant-input');
        if (wrapper) wrapper.style.display = '';

        if (!lbl._fkBound) {
          lbl._fkBound = true;
          bcpoBound = true;
          lbl.addEventListener('click', guardedOpenModal);
        } else {
          bcpoBound = true;
        }
      }
    });

    // 2. Wenn native Trigger gefunden → CTA verstecken
    if (bcpoBound && ctaEl) {
      ctaEl.style.display = 'none';
    }

    // 3. Wenn KEINE nativen Trigger → Wunschfarbe-Labels verstecken und CTA einfügen
    if (!bcpoBound) {
      var labels = document.querySelectorAll(
        'fieldset label, .product-form__input label, .selector-wrapper label'
      );
      labels.forEach(function (lbl) {
        var text = lbl.textContent || '';
        if (text.indexOf('Wunschfarb') !== -1) {
          if (!colorContainer) colorContainer = lbl.parentNode;
          lbl.style.display = 'none';
          var input = lbl.querySelector('input') || (lbl.previousElementSibling && lbl.previousElementSibling.tagName === 'INPUT' ? lbl.previousElementSibling : null);
          if (input) input.style.display = 'none';
        }
      });

      if (colorContainer && ctaEl) {
        colorContainer.appendChild(ctaEl);
      }
    }

    var containerSelectors = [
      'fieldset.product-form__input',
      '.product-form__input--dropdown',
      'fieldset.variant-option',
      '.selector-wrapper',
      'variant-selects',
      'variant-radios',
      'variant-picker fieldset'
    ];
    containerSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var text = el.textContent || '';
        if (text.indexOf('Preisgruppe') !== -1) {
          el.style.display = 'none';
        }
      });
    });

    document.querySelectorAll('select option').forEach(function (opt) {
      if (opt.textContent.indexOf('Wunschfarb') !== -1) {
        opt.style.display = 'none';
        if (opt.selected) {
          var select = opt.closest('select');
          if (select && select.options.length > 0) {
            select.selectedIndex = 0;
          }
        }
      }
    });

    resumeObserver();
  }

  /* ---- Variant DOM re-render observer ---- */
  function observeVariantChanges() {
    variantObserverTarget =
      document.querySelector('variant-selects') ||
      document.querySelector('variant-radios') ||
      document.querySelector('variant-picker') ||
      document.querySelector('[data-product-form]') ||
      document.querySelector('.product-form') ||
      document.querySelector('.product-single__form') ||
      document.querySelector('.product-single__meta');

    if (!variantObserverTarget) return;

    var debounceTimer = null;
    variantObserver = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        hideNativeVariants();
      }, 50);
    });

    variantObserver.observe(variantObserverTarget, { childList: true, subtree: true });
  }

  /* ---- Click-Gate ---- */
  function getCurrentSelectedSize() {
    // Form input[name="id"] ist der robusteste theme-übergreifende Signalpfad
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!input || !input.value) return null;
    return state.sizeByVariantId[input.value] || null;
  }

  function canOpenModal() {
    if (!state.hasSize) return true;          // einzige Wunschfarbe-Variante, kein Größen-Gate
    var current = getCurrentSelectedSize();
    if (!current) return true;                // defensiv: keine Größe lesbar → erlauben
    var n = normalizeSize(current);
    if (!n) return true;                      // unparseable → erlauben
    return !!(state.wunschfarbeSizes && state.wunschfarbeSizes[n]);
  }

  function guardedOpenModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!canOpenModal()) return;
    openModal();
  }

  /* ---- Modal ---- */
  function openModal() {
    if (!dom.overlay) return;
    state.modalOpen = true;
    // Measure sticky header height and set CSS custom property
    var headerHeight = 0;
    var selectors = ['header', '.header', '#header', '.site-header', '#shopify-section-header', '.shopify-section-header'];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        var style = window.getComputedStyle(el);
        if (style.position === 'sticky' || style.position === 'fixed') {
          headerHeight = el.getBoundingClientRect().height;
          break;
        }
      }
    }
    dom.overlay.style.setProperty('--fk-header-offset', Math.ceil(headerHeight) + 'px');
    dom.overlay.classList.add('fk-modal-overlay--open');
    dom.overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fk-modal-open');
    dom.modal.focus();
  }

  function closeModal() {
    if (!dom.overlay) return;
    state.modalOpen = false;
    dom.overlay.classList.remove('fk-modal-overlay--open');
    dom.overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fk-modal-open');
    var ctaBtn = document.getElementById('fk-cta');
    if (ctaBtn) ctaBtn.focus();
  }

  function bindModalEvents() {
    if (dom.closeBtn) dom.closeBtn.addEventListener('click', closeModal);
    if (dom.overlay) {
      dom.overlay.addEventListener('click', function (e) {
        if (e.target === dom.overlay) closeModal();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.modalOpen) closeModal();
    });
  }

  /* ---- Step 1: Gebindegrößen ---- */
  function renderSizes() {
    // Größen aus Price-Lookup nehmen (wenn vorhanden), sonst aus Varianten
    var sizesSet = {};

    if (state.priceLookup && state.skuPrefix && state.priceLookup[state.skuPrefix]) {
      var productPrices = state.priceLookup[state.skuPrefix].sizes;
      Object.keys(productPrices).forEach(function (size) {
        sizesSet[size] = true;
      });
    } else {
      state.variants.forEach(function (v) {
        if (v.size && !sizesSet[v.size]) sizesSet[v.size] = true;
      });
    }

    // Nur Größen anzeigen, für die eine Wunschfarbton-Variante existiert
    if (state.wunschfarbeSizes) {
      Object.keys(sizesSet).forEach(function (size) {
        var n = normalizeSize(size);
        if (!n || !state.wunschfarbeSizes[n]) delete sizesSet[size];
      });
    }

    var sizes = Object.keys(sizesSet);
    sizes.sort(function (a, b) {
      var numA = parseFloat(a.replace(',', '.'));
      var numB = parseFloat(b.replace(',', '.'));
      return numA - numB;
    });

    var html = '';
    sizes.forEach(function (size) {
      html += '<button type="button" class="fk-size-btn" data-size="' + escHtml(size) + '">' + escHtml(size) + '</button>';
    });
    dom.sizes.innerHTML = html;
  }

  /* ---- Step 2: Farbfamilien ---- */
  function renderFamilies() {
    var html = '';
    state.families.forEach(function (fam) {
      var rgb = fam.representativeRgb;
      var bgColor = 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
      html += '<button type="button" class="fk-family-btn" data-family-id="' + escHtml(fam.id) + '">'
        + '<span class="fk-family-btn__swatch" style="background:' + bgColor + '"></span>'
        + '<span>'
        + '<span class="fk-family-btn__name">' + escHtml(fam.name) + '</span><br>'
        + '<span class="fk-family-btn__count">' + fam.colors.length + ' Farbtöne</span>'
        + '</span>'
        + '</button>';
    });
    dom.families.innerHTML = html;
  }

  function selectFamily(familyId) {
    var family = state.families.find(function (f) { return f.id === familyId; });
    if (!family) return;
    state.selectedFamily = family;
    dom.familyTitle.textContent = family.name;
    goToStep(3);
    renderColors(family.colors);
  }

  /* ---- Step 3: Farbfelder ---- */
  function renderColors(colors) {
    var html = '';
    colors.forEach(function (c) {
      var bgColor = 'rgb(' + c.rgb.r + ',' + c.rgb.g + ',' + c.rgb.b + ')';
      var isDark = luminance(c.rgb.r, c.rgb.g, c.rgb.b) < 0.45;
      var contrastClass = isDark ? 'fk-color-swatch--dark' : 'fk-color-swatch--light';
      var ralLabel = c.ral ? '<span class="fk-color-swatch__ral">' + escHtml(c.ral) + '</span>' : '';

      html += '<div class="fk-color-swatch ' + contrastClass + '" '
        + 'data-color-id="' + escHtml(c.id) + '" '
        + 'style="background:' + bgColor + '" '
        + 'tabindex="0" '
        + 'role="button" '
        + 'title="' + escHtml(c.id) + (c.ral ? ' (' + escHtml(c.ral) + ')' : '') + ' — HBW ' + c.hbw + '">'
        + '<span class="fk-color-swatch__id">' + escHtml(c.id) + '</span>'
        + ralLabel
        + '</div>';
    });
    dom.colors.innerHTML = html;
  }

  function selectColor(colorId) {
    var color = state.colors.find(function (c) { return c.id === colorId; });
    if (!color) return;
    state.selectedColor = color;

    // Preis aus Lookup ermitteln
    state.resolvedPrice = lookupPrice(color.price_group, state.selectedSize);

    // Shopify-Variante finden (für Add-to-Cart — die "Wunschfarbe"-Variante)
    var variant = state.variants.find(function (v) {
      if (state.hasSize) return v.size === state.selectedSize;
      return true;
    });
    state.matchedVariant = variant || null;

    updateSummary();
  }

  /* ---- Zusammenfassung ---- */
  function updateSummary() {
    var color = state.selectedColor;
    if (!color) return;

    var bgColor = 'rgb(' + color.rgb.r + ',' + color.rgb.g + ',' + color.rgb.b + ')';
    dom.summarySwatch.style.background = bgColor;
    dom.summaryId.textContent = 'Scala ' + color.id;
    dom.summaryName.textContent = color.family_name + (color.ral ? ' (' + color.ral + ')' : '');
    dom.summarySize.textContent = (state.hasSize && state.selectedSize ? state.selectedSize + ' — ' : '') + 'PG' + color.price_group;

    var grossPrice = null;
    if (state.resolvedPrice) {
      // Brutto-Preis aus Lookup anzeigen
      grossPrice = state.resolvedPrice.gross;
      dom.summaryPrice.textContent = formatPrice(grossPrice);
      dom.addToCart.disabled = !state.matchedVariant;
    } else if (state.matchedVariant) {
      // Fallback: Varianten-Preis (wenn kein Lookup-Eintrag)
      grossPrice = state.matchedVariant.price / 100;
      dom.summaryPrice.textContent = formatPrice(grossPrice);
      dom.addToCart.disabled = false;
    } else {
      dom.summaryPrice.textContent = '—';
      dom.addToCart.disabled = true;
      showFeedback('Kein Preis verfügbar für PG' + color.price_group + (state.selectedSize ? ', ' + state.selectedSize : ''), 'error');
    }

    // Grundpreis (€/l) anzeigen
    var liters = parseSize(state.selectedSize);
    if (grossPrice && liters) {
      dom.summaryUnitPrice.textContent = '(' + formatPrice(grossPrice / liters) + ' / l)';
    } else {
      dom.summaryUnitPrice.textContent = '';
    }

    dom.summary.classList.add('fk-summary--visible');
    dom.feedback.textContent = '';
    dom.feedback.className = 'fk-summary__feedback';
  }

  /* ---- Suche ---- */
  function performSearch(query) {
    var results = state.colors.filter(function (c) {
      return c.id.toLowerCase().indexOf(query) !== -1
        || c.family_name.toLowerCase().indexOf(query) !== -1
        || (c.ral && c.ral.toLowerCase().indexOf(query) !== -1)
        || (c.name && c.name.toLowerCase().indexOf(query) !== -1);
    }).slice(0, 12);

    if (results.length === 0) {
      dom.searchResults.classList.remove('fk-search__results--open');
      dom.searchResults.innerHTML = '';
      return;
    }

    var html = '';
    results.forEach(function (c) {
      var bgColor = 'rgb(' + c.rgb.r + ',' + c.rgb.g + ',' + c.rgb.b + ')';
      var meta = c.family_name + (c.ral ? ' · ' + c.ral : '') + ' · HBW ' + c.hbw;
      html += '<div class="fk-search__result" data-color-id="' + escHtml(c.id) + '" data-family-id="' + escHtml(c.family_id) + '">'
        + '<span class="fk-search__result-swatch" style="background:' + bgColor + '"></span>'
        + '<span class="fk-search__result-info">'
        + '<span class="fk-search__result-id">' + escHtml(c.id) + '</span>'
        + '<span class="fk-search__result-meta">' + escHtml(meta) + '</span>'
        + '</span>'
        + '</div>';
    });
    dom.searchResults.innerHTML = html;
    dom.searchResults.classList.add('fk-search__results--open');

    dom.searchResults.querySelectorAll('.fk-search__result').forEach(function (el) {
      el.addEventListener('mousedown', function (e) {
        e.preventDefault();
        var colorId = el.getAttribute('data-color-id');
        var familyId = el.getAttribute('data-family-id');
        dom.search.value = '';
        dom.searchResults.classList.remove('fk-search__results--open');
        selectFamily(familyId);
        setTimeout(function () {
          selectColor(colorId);
          var swatch = dom.colors.querySelector('[data-color-id="' + colorId + '"]');
          if (swatch) {
            dom.colors.querySelectorAll('.fk-color-swatch').forEach(function (s) { s.classList.remove('fk-color-swatch--active'); });
            swatch.classList.add('fk-color-swatch--active');
            swatch.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }, 50);
      });
    });
  }

  /* ---- Wizard Events ---- */
  function bindWizardEvents() {
    dom.sizes.addEventListener('click', function (e) {
      var btn = e.target.closest('.fk-size-btn');
      if (!btn) return;
      state.selectedSize = btn.getAttribute('data-size');
      dom.sizes.querySelectorAll('.fk-size-btn').forEach(function (b) { b.classList.remove('fk-size-btn--active'); });
      btn.classList.add('fk-size-btn--active');
      goToStep(2);
      renderFamilies();
    });

    dom.families.addEventListener('click', function (e) {
      var btn = e.target.closest('.fk-family-btn');
      if (!btn) return;
      selectFamily(btn.getAttribute('data-family-id'));
    });

    dom.colors.addEventListener('click', function (e) {
      var swatch = e.target.closest('.fk-color-swatch');
      if (!swatch) return;
      selectColor(swatch.getAttribute('data-color-id'));
      dom.colors.querySelectorAll('.fk-color-swatch').forEach(function (s) { s.classList.remove('fk-color-swatch--active'); });
      swatch.classList.add('fk-color-swatch--active');
    });

    var searchTimeout;
    dom.search.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      var query = dom.search.value.trim().toLowerCase();
      if (query.length < 2) {
        dom.searchResults.classList.remove('fk-search__results--open');
        dom.searchResults.innerHTML = '';
        return;
      }
      searchTimeout = setTimeout(function () { performSearch(query); }, 150);
    });

    dom.search.addEventListener('blur', function () {
      setTimeout(function () {
        dom.searchResults.classList.remove('fk-search__results--open');
      }, 200);
    });

    dom.modal.querySelectorAll('.fk-back').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = parseInt(btn.getAttribute('data-back'), 10);
        if (!state.hasSize && target === 1) return;
        goToStep(target);
      });
      if (!state.hasSize && btn.getAttribute('data-back') === '1') {
        btn.style.display = 'none';
      }
    });

    dom.addToCart.addEventListener('click', addToCart);
  }

  /* ---- Add to Cart ---- */
  function addToCart() {
    if (!state.matchedVariant || !state.selectedColor) return;

    dom.addToCart.classList.add('fk-add-to-cart--loading');
    dom.addToCart.textContent = 'Wird hinzugefügt…';

    var properties = {
      'Farbton': 'Scala ' + state.selectedColor.id,
      'Farbfamilie': state.selectedColor.family_name,
      'HBW': String(state.selectedColor.hbw),
      'Preisgruppe': 'PG' + state.selectedColor.price_group
    };

    if (state.selectedColor.ral) {
      properties['RAL'] = state.selectedColor.ral;
    }

    // Preis-SKU aus Lookup mitgeben (für Backend-Zuordnung)
    if (state.resolvedPrice && state.resolvedPrice.sku) {
      properties['_sku_abtoenung'] = state.resolvedPrice.sku;
    }

    // Brutto-Preis in Cent für Cart Transform (Preisanpassung im Warenkorb)
    if (state.resolvedPrice && state.resolvedPrice.gross) {
      properties['_target_gross_cents'] = String(Math.round(state.resolvedPrice.gross * 100));
      properties['Preis'] = formatPrice(state.resolvedPrice.gross);
    }

    var body = {
      items: [{
        id: state.matchedVariant.id,
        quantity: 1,
        properties: properties
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Fehler beim Hinzufügen');
      return response.json();
    })
    .then(function () {
      showFeedback('Erfolgreich in den Warenkorb gelegt!', 'success');
      dispatchCartUpdate();
      setTimeout(function () {
        closeModal();
        resetAddToCartButton();
      }, 600);
    })
    .catch(function (err) {
      showFeedback('Fehler: ' + err.message, 'error');
      resetAddToCartButton();
    });
  }

  function resetAddToCartButton() {
    dom.addToCart.textContent = dom.addToCart.getAttribute('data-original-text') || 'In den Warenkorb';
    dom.addToCart.classList.remove('fk-add-to-cart--loading');
  }

  function dispatchCartUpdate() {
    var cartItemsEl = document.querySelector('cart-items-component');
    var sectionId = cartItemsEl ? cartItemsEl.getAttribute('data-section-id') : null;

    var cartPromise = fetch('/cart.js').then(function (r) { return r.json(); });
    var sectionPromise = sectionId
      ? fetch('/?sections=' + sectionId, { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .catch(function () { return {}; })
      : Promise.resolve({});

    Promise.all([cartPromise, sectionPromise])
      .then(function (results) {
        var cart = results[0];
        var sections = results[1];

        // 1. Cart-Drawer-Inhalt aktualisieren
        if (cartItemsEl && sectionId && sections[sectionId]) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections[sectionId];
          var newCartItems = tmp.querySelector('cart-items-component');
          if (newCartItems) {
            cartItemsEl.innerHTML = newCartItems.innerHTML;
          }
        }

        // 2. Counter aktualisieren — alle bekannten Theme-Selektoren
        var selectors = [
          '[data-cart-count]',
          '.cart-count-bubble span',
          '.cart-bubble__text-count',
          '#cart-bubble-text .cart-bubble__text-count',
          '#cart-icon-bubble span[aria-hidden]',
          '.cart-link__bubble-num'
        ];
        document.querySelectorAll(selectors.join(', ')).forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var bubble = document.querySelector('.cart-bubble');
        if (bubble) {
          bubble.style.display = cart.item_count > 0 ? '' : 'none';
        }

        // 3. Expanse/Legacy-Themes: Cart-Drawer aktualisieren oder Seite neu laden
        if (!cartItemsEl) {
          if (typeof window.ajaxCart !== 'undefined' && typeof window.ajaxCart.load === 'function') {
            window.ajaxCart.load();
          } else if (typeof theme !== 'undefined' && theme.cart && typeof theme.cart.updateAll === 'function') {
            theme.cart.updateAll();
          } else {
            window.location.reload();
          }
        }
      })
      .catch(function () {});
  }

  /* ---- Navigation ---- */
  function goToStep(step) {
    var modal = dom.modal;
    modal.querySelectorAll('.fk-panel').forEach(function (p) { p.classList.remove('fk-panel--active'); });
    modal.querySelector('[data-panel="' + step + '"]').classList.add('fk-panel--active');

    modal.querySelectorAll('.fk-step').forEach(function (s) {
      var sStep = parseInt(s.getAttribute('data-step'), 10);
      s.classList.remove('fk-step--active', 'fk-step--done');
      if (sStep === step) s.classList.add('fk-step--active');
      else if (sStep < step) s.classList.add('fk-step--done');
    });

    if (step < 3 || !state.selectedColor) {
      dom.summary.classList.remove('fk-summary--visible');
    }
  }

  /* ---- Utilities ---- */
  // Spiegelt normalizeSizeToLookupKey aus app/lib/variant-sync.ts:86
  // "2,5 l" → "2,5 Liter", "10,0 l" → "10 Liter", behält " mit Protect" Suffix
  function normalizeSize(s) {
    if (!s) return null;
    var t = String(s).trim();
    var m = t.match(/^([\d]+[,.]?\d*)\s*(l|liter|kg|kilogramm?)(\s+mit\s+Protect)?$/i);
    if (!m) return null;
    var num = m[1].replace('.', ',').replace(/,0$/, '');
    var unit = m[2].toLowerCase().charAt(0) === 'l' ? 'Liter' : 'kg';
    var suffix = m[3] ? ' mit Protect' : '';
    return num + ' ' + unit + suffix;
  }

  function parseSize(sizeStr) {
    if (!sizeStr) return null;
    var m = sizeStr.match(/([\d]+[,.]?\d*)/);
    return m ? parseFloat(m[1].replace(',', '.')) : null;
  }

  function luminance(r, g, b) {
    var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }

  function formatPrice(euros) {
    return euros.toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function escHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function showFeedback(msg, type) {
    dom.feedback.textContent = msg;
    dom.feedback.className = 'fk-summary__feedback fk-summary__feedback--' + type;
  }

  /* ---- Start ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
